
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiObjectDerelict as ObiObjectDerelictElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-object-derelict.js';
 
 
 

 
 export const ObiObjectDerelict = createComponent({
   react: React,
   tagName: 'obi-object-derelict',
   elementClass: ObiObjectDerelictElement,
   events: {
     
   }
  });
 
 